import axios from 'axios'
import React from 'react'
import { baseUrl } from '../config/clientsConfig'


const AutoMessageService = {
  creactionDataAutoMessage: async (data) => {
    return axios.get(`${baseUrl}/creation-data`)
  },
  createAutoMessage: async (data) => {
    return axios.post(`${baseUrl}/create-automation-template`, data)
  },
  getAutoMessage: async () => {
    return axios.get(`${baseUrl}/get-automation-templates`)
  },
  getAutoMessageById: async (id) => {
    return axios.get(`${baseUrl}/get-automation-template-info?id=${id}`)
  },
  updateAutoMessage : async (data) => {
    return axios.put(`${baseUrl}/update-automation-template`, data)
  },
  statusUpdateAutoMessage: async (data) => {
    return axios.put(`${baseUrl}/status-change-automation-template`, data)
  },
  deleteAutoMessage: async (data) => {
    return axios.post(`${baseUrl}/delete-automation-template`, data )
  },
  sendSingleLeadAutoMessage: async (data) => {
    return axios.post(`${baseUrl}/leads/send-welcome-message`, data)
  }

  
}

export default AutoMessageService
